var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 11.5,
    fill: "#F4F6FE",
    stroke: "#1737E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6652 14.4394L14.5608 14.3133C14.2956 14.2828 14.0348 14.3742 13.8478 14.5611L13.0478 15.3611C11.8174 14.735 10.8087 13.7307 10.1826 12.4959L10.9869 11.6915C11.1739 11.5046 11.2652 11.2437 11.2348 10.9785L11.1087 9.88285C11.0565 9.44372 10.6869 9.11328 10.2435 9.11328H9.49128C8.99998 9.11328 8.59128 9.52198 8.62171 10.0133C8.85215 13.7263 11.8217 16.6915 15.5304 16.922C16.0217 16.9524 16.4304 16.5437 16.4304 16.0524V15.3002C16.4348 14.8611 16.1043 14.4915 15.6652 14.4394Z",
    fill: "#1737E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallA);
export default __webpack_public_path__ + "static/media/call_a.548073295e5bae24e1bdacadffbfed99.svg";
export { ForwardRef as ReactComponent };